'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { ProductStockStatus } from '@/fo/api/magento';
import { UiKitLabelBase } from '@/fo/ui/kit/label/base';
import { StockStatus } from '@/fo/util/map-product-data';

import { styles } from './UiProductTileSearch.styles';

export interface UiProductTileSearchProps {
  className?: string;
  link: string;
  /** Изображение товара */
  image: string;
  /** Статус наличия товара */
  stockStatus: StockStatus;
  /** Название товара */
  title: string;
  /** Название серии */
  series: string;
  /** Текущая цена */
  price: number | null;
  /** Старая цена */
  oldPrice?: number | null;
  /** Валюта */
  currency?: string;
}

export function UiProductTileSearch({
  className,
  link,
  image,
  stockStatus,
  title,
  series
}: UiProductTileSearchProps) {
  const t = useTranslations();
  const slots = styles();
  const isOutOfStock = stockStatus === ProductStockStatus.OutOfStock;

  return (
    <article
      className={slots.base({ className })}
      itemScope
      itemType="https://schema.org/Product"
    >
      {/* Скрытые метаданные для микроразметки */}
      <meta
        itemProp="url"
        content={link}
      />
      <meta
        itemProp="brand"
        itemScope
        itemType="https://schema.org/Brand"
        content="Brand"
      />

      <div className={slots.imageContainer()}>
        <div
          className={slots.imageWrapper({
            className: isOutOfStock
              ? 'after:absolute after:top-0 after:right-0 after:bottom-0 after:left-0 after:rounded-[8px] after:bg-white after:opacity-50'
              : ''
          })}
        >
          <Image
            className={slots.image()}
            width={324}
            height={324}
            src={image}
            alt={title}
            itemProp="image"
          />
        </div>

        {isOutOfStock && (
          <UiKitLabelBase
            color="black"
            className={slots.outOfStockLabel()}
            type="search"
          >
            {t('Out of stock')}
          </UiKitLabelBase>
        )}
      </div>

      <div className={slots.content()}>
        <Link
          className={slots.link({
            className: isOutOfStock ? 'bg-white opacity-50' : ''
          })}
          href={link}
        />

        <div className={slots.bottom()}>
          <h2
            className={slots.info()}
            itemProp="name"
          >
            <span
              className={slots.title()}
              dangerouslySetInnerHTML={{ __html: `${series} ${title}` }}
            />
          </h2>
        </div>
      </div>
    </article>
  );
}
